import { type PropsWithChildren } from 'react';

import { MutationSignalContext } from '@spotify/confidence-graphql';

import { useRecentActivity } from './useRecentActivity';

export const RecentActivityProvider = ({ children }: PropsWithChildren) => {
  const { recordActivity } = useRecentActivity();

  return (
    <MutationSignalContext.Provider value={recordActivity}>
      {children}
    </MutationSignalContext.Provider>
  );
};
